import Vue from 'vue';
import { VTooltip, VPopover, VClosePopover } from 'v-tooltip';
import { gaEvent } from './ga-directives';
import { clickOutside } from './click-outside';

Vue.directive('gaEvent', gaEvent);
Vue.directive('click-outside', clickOutside);
Vue.directive('tooltip', VTooltip);
Vue.directive('close-popover', VClosePopover);
// Vue.component('v-popover', VPopover);

Vue.directive("currency", {
  bind(el, binding, vnode) {
    el.value = binding.value && (Number(binding.value) | 0).toLocaleString('en-AU', {
      style: 'currency',
      currency: (!binding.arg ? 'AUD' : binding.arg),
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
    el.onblur = function (e) {
      e.target.value = (Number(e.target.value) | 0).toLocaleString('en-AU', {
        style: 'currency',
        currency: (!binding.arg ? 'AUD' : binding.arg),
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    };
    el.onfocus = function (e) {
      e.target.value =
        e.target.value && Number(e.target.value.replace(/[^\d.]/g, ""));
    };
    el.oninput = function (e) {
      vnode.context.$data[binding.expression] = e.target.value;
    };
  }
});